/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_AcceptInputs */

const es_cap_jpc_accept = /** @type {(inputs: Cap_Jpc_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar salida`)
};

const gl_cap_jpc_accept = /** @type {(inputs: Cap_Jpc_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptar saída`)
};

const en_cap_jpc_accept = /** @type {(inputs: Cap_Jpc_AcceptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accept trip`)
};

/**
* | output |
* | --- |
* | "Accept trip" |
*
* @param {Cap_Jpc_AcceptInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_accept = /** @type {((inputs?: Cap_Jpc_AcceptInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_AcceptInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_accept(inputs)
	if (locale === "en") return en_cap_jpc_accept(inputs)
	return es_cap_jpc_accept(inputs)
});